import { render, staticRenderFns } from "./PermissionFilterBar.vue?vue&type=template&id=32c86a6c"
import script from "./PermissionFilterBar.vue?vue&type=script&lang=js"
export * from "./PermissionFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports